export type IPrintArea = (e: JQueryEventObject) => void;

export function printArea(e: JQueryEventObject) {
  const $button = $(e.currentTarget);
  const originalContents = document.body.innerHTML;
  const $target = $(`#${$button.data('target')}`);
  const printContents = $target.html();
  document.body.innerHTML = printContents;
  window.print();
  document.body.innerHTML = originalContents;
}
